import { IPricingTypes } from 'types/graphqlTypes'
import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'

export const formatPostalCode = (
  postalCode: string | undefined,
  postalCode3: string | undefined
) => {
  if (postalCode) {
    return postalCode
  }
  if (postalCode3) {
    return `${postalCode3}--`
  }
  return DISPLAY.empty
}

export const formatLocation = (
  city: string | undefined,
  stateCode: string | undefined,
  postalCode?: string | undefined,
  postalCode3?: string | undefined
) => {
  const location: string[] = []

  if (city) {
    location.push(capitalize(city))
  }
  if (stateCode) {
    location.push(stateCode)
  }
  if (postalCode || postalCode3) {
    location.push(formatPostalCode(postalCode, postalCode3))
  }

  if (location.length === 0) return DISPLAY.empty

  return location.join(', ')
}

export const formatMiles = (miles: number | undefined) => (miles ? miles.toFixed(1) : DISPLAY.empty)

export const formatPricingProgram = (
  pricingType: string | undefined,
  pricingProgram: string | undefined
) => {
  if (pricingType === IPricingTypes.variable) {
    return ''
  }
  if (pricingProgram) {
    return pricingProgram
  }
  return 'Standard'
}
